{
  "actions": {
    "cancel": "إلغاء"
  },
  "list": {
    "title": "المنسقون والعمولات",
    "subtitle": "{{n}} منسقين نشطين · بدون رواتب، حصة من رسم كل حجز",
    "new": "منسق جديد",
    "caption": "المنسقون",
    "stats": {
      "remaining": "إجمالي المتبقي للتحويل",
      "pending": "عمولات معلّقة",
      "pendingSub": "حجوزات لم يدفعها العملاء بعد",
      "transferredThisMonth": "حُوّل هذا الشهر"
    },
    "empty": {
      "title": "لا يوجد منسقون",
      "action": "إضافة منسق"
    },
    "columns": {
      "name": "المنسق",
      "agreement": "الاتفاقية السارية",
      "monthBookings": "حجوزات الشهر",
      "earned": "المستحق",
      "transferred": "المحوَّل",
      "remaining": "المتبقي",
      "pending": "المعلّق",
      "portal": "البوابة"
    },
    "dialog": {
      "title": "منسق جديد",
      "description": "بدون راتب — حصة من رسم كل حجز حسب الاتفاقية."
    }
  },
  "form": {
    "firstName": "الاسم الأول",
    "lastName": "اسم العائلة",
    "nationalId": "رقم الهوية",
    "nationalIdHint": "يُحفظ مشفراً ولا يظهر كاملاً إلا بطلب مسجّل",
    "phone": "الجوال",
    "email": "البريد",
    "emailHint": "يُستخدم لدخول بوابة المنسق",
    "agreementType": "نوع الاتفاقية",
    "typePercentage": "نسبة من الرسم",
    "typeFixed": "مبلغ ثابت لكل حجز",
    "percentLabel": "النسبة (%)",
    "amountLabel": "المبلغ ({{currency}})",
    "validFrom": "سارية من",
    "saving": "جاري الحفظ…",
    "save": "حفظ البيانات",
    "create": "إضافة المنسق",
    "saved": "تم حفظ البيانات",
    "saveFailed": "تعذر الحفظ",
    "errors": {
      "firstName": "الاسم الأول مطلوب",
      "lastName": "اسم العائلة مطلوب",
      "phone": "رقم جوال غير صالح",
      "email": "بريد إلكتروني غير صالح",
      "nationalId": "10 أرقام تبدأ بـ 1 أو 2",
      "valuePositive": "أدخل قيمة أكبر من صفر",
      "percentMax": "النسبة لا تتجاوز 100%"
    },
    "whatsapp": "رقم واتساب الوكالة المخصص",
    "whatsappHint": "رقم تملكه الوكالة ويستخدمه المنسق مع العملاء — يُحفظ في النظام فقط ولا يظهر في العقد",
    "createdWithContract": "تم إضافة المنسق وإرسال العقد للتوقيع",
    "contractSetupMissing": "لا يمكن إضافة منسق قبل إكمال إعداد «عقد المنسق» (ممثل الوكالة وتوقيعها).",
    "openSettings": "فتح الإعدادات",
    "contractWillBeSent": "سيُرسل العقد إلى بريد المنسق ليقرأه ويوقّعه إلكترونياً، ثم يختار كلمة المرور لبوابته. يُرفق العقد الموقّع بالاتفاقية تلقائياً."
  },
  "detail": {
    "edit": "تعديل البيانات",
    "recordPayout": "تسجيل تحويل",
    "nothingRemaining": "لا يوجد مبلغ متبقٍ للتحويل",
    "editDialogTitle": "تعديل بيانات المنسق",
    "stats": {
      "earned": "إجمالي المستحق",
      "transferred": "المحوَّل",
      "owed": "مستحق على المنسق",
      "remaining": "المتبقي للتحويل",
      "pending": "معلّق (لم يُدفع الحجز)"
    },
    "tabs": {
      "ledger": "كشف العمولات",
      "payouts": "التحويلات والإيصالات",
      "agreements": "الاتفاقيات",
      "contracts": "العقود"
    }
  },
  "ledger": {
    "status": "الحالة",
    "allStatuses": "كل الحالات",
    "month": "الشهر",
    "export": "تصدير CSV",
    "caption": "كشف العمولات",
    "empty": "لا توجد عمولات",
    "columns": {
      "booking": "الحجز",
      "customer": "العميل",
      "fee": "الرسم",
      "share": "الحصة",
      "date": "التاريخ",
      "status": "الحالة"
    }
  },
  "payouts": {
    "caption": "التحويلات",
    "empty": "لا توجد تحويلات بعد",
    "voided": "تم إلغاء التحويل وإعادة العمولات إلى مستحقة",
    "viewReceipt": "عرض الإيصال",
    "voidLabel": "إلغاء التحويل بتاريخ {{date}}",
    "voidConfirm": "إلغاء هذا التحويل؟ تعود العمولات المشمولة إلى حالة مستحقة.",
    "void": "إلغاء",
    "methods": {
      "bank_transfer": "تحويل بنكي",
      "cash": "نقداً"
    },
    "columns": {
      "date": "التاريخ",
      "amount": "المبلغ",
      "method": "الطريقة",
      "reference": "المرجع البنكي",
      "receipt": "الإيصال",
      "recordedBy": "سجّله"
    }
  },
  "profile": {
    "title": "البيانات",
    "nationalId": "رقم الهوية",
    "reveal": "إظهار رقم الهوية (يُسجَّل)",
    "phone": "الجوال",
    "email": "البريد",
    "agreement": "الاتفاقية",
    "from": "من {{date}}",
    "changeEmail": "تغيير البريد",
    "whatsapp": "واتساب الوكالة",
    "noWhatsapp": "غير محدد"
  },
  "portal": {
    "title": "حساب بوابة المنسق",
    "lastLogin": "آخر دخول {{when}}",
    "note": "يرى المنسق في البوابة حجوزاته وحصته فقط (المستحق، المحوَّل، المتبقي، المعلّق) وإيصالات التحويل — دون الرسوم أو بيانات تواصل العملاء.",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "disable": "إيقاف",
    "enable": "تفعيل",
    "toasts": {
      "reset": "تم إرسال رابط إعادة التعيين",
      "disabled": "تم إيقاف الحساب",
      "enabled": "تم تفعيل الحساب",
      "linkResent": "أُرسل رابط تعيين كلمة المرور مجدداً"
    },
    "contract": "العقد:",
    "awaitingContract": "يُنشأ حساب البوابة بعد توقيع المنسق للعقد.",
    "noContract": "لا يوجد عقد بانتظار التوقيع. أرسل العقد ليتمكن المنسق من الدخول.",
    "signedNoPassword": "وقّع المنسق العقد ولم يختر كلمة المرور بعد.",
    "sendContract": "إرسال العقد",
    "resendLink": "إعادة إرسال رابط كلمة المرور"
  },
  "payoutDialog": {
    "title": "تسجيل تحويل عمولة",
    "remaining": "{{name}} · المتبقي",
    "entries": "العمولات المشمولة بالتحويل",
    "reversal": "قيد معكوس (إلزامي)",
    "amount": "المبلغ المحوَّل ({{currency}})",
    "paidAt": "تاريخ التحويل",
    "reference": "المرجع البنكي",
    "receipt": "إيصال التحويل",
    "info": "سيظهر التحويل والإيصال في بوابة المنسق فور الحفظ.",
    "save": "حفظ التحويل",
    "recorded": "تم تسجيل التحويل"
  },
  "agreements": {
    "intro": "جدول اتفاقية لتاريخ قادم أو غيّر الاتفاقية الحالية اعتباراً من اليوم. يصل المنسق إشعار في البوابة وبريد إلكتروني بكل تغيير، والحجوزات المؤكدة سابقاً تحتفظ باتفاقيتها.",
    "new": "اتفاقية جديدة",
    "rangeTo": "من {{from}} إلى {{to}}",
    "rangeOpen": "من {{from}} — مفتوحة",
    "viewFile": "عرض ملف الاتفاقية",
    "file": "الملف",
    "editScheduled": "تعديل الاتفاقية المجدولة",
    "cancelScheduled": "إلغاء الاتفاقية المجدولة",
    "cancelDescription": "ستُلغى الاتفاقية ({{label}}) المجدولة من {{date}}، وتستمر الاتفاقية الحالية. سيُشعَر المنسق.",
    "cancelConfirm": "إلغاء الاتفاقية",
    "cancelled": "تم إلغاء الاتفاقية المجدولة وإشعار المنسق",
    "empty": "لا توجد اتفاقيات.",
    "fileTitle": "ملف الاتفاقية",
    "dialog": {
      "titleEdit": "تعديل الاتفاقية المجدولة",
      "titleNew": "اتفاقية جديدة",
      "startsToday": "تسري اعتباراً من اليوم وتُغلق الاتفاقية الحالية.",
      "startsLater": "تبدأ في التاريخ المحدد، وتستمر الاتفاقية الحالية حتى اليوم السابق له.",
      "typePercentage": "نسبة من الرسم",
      "typeFixed": "مبلغ ثابت",
      "percentLabel": "النسبة (%)",
      "amountLabel": "المبلغ ({{currency}})",
      "validFrom": "سارية من",
      "supersedeOne": "ستحل هذه الاتفاقية محل اتفاقية تبدأ في نفس التاريخ أو بعده، وستُلغى تلك الاتفاقية.",
      "supersedeMany": "ستحل هذه الاتفاقية محل {{n}} اتفاقيات تبدأ في نفس التاريخ أو بعده، وستُلغى.",
      "saveEdit": "حفظ التعديلات",
      "change": "تغيير الاتفاقية",
      "schedule": "جدولة الاتفاقية",
      "edited": "تم تعديل الاتفاقية وإشعار المنسق",
      "changed": "تم تغيير الاتفاقية اعتباراً من اليوم وإشعار المنسق",
      "scheduled": "تمت جدولة الاتفاقية وإشعار المنسق",
      "contractNote": "عند الحفظ يُرسل عقد جديد بهذه الشروط إلى بريد المنسق ليوقّعه، ويُرفق العقد الموقّع بالاتفاقية تلقائياً."
    },
    "awaitingSignature": "بانتظار التوقيع"
  }
}
